// extracted by css-extract-rspack-plugin
export default {"wrapper":"ProjectGroupAccessRightOverlayController_wrapper__nbBFc"};